module.exports = __webpack_public_path__ + "static/img/login-left.8d4bec9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/login/login-left.png
// module id = qNJZ
// module chunks = 62